import mapProps from 'recompose/mapProps';

export default mapProps(props => {
	const {
		name,
		values,
		errors,
		touched,
		helperText,
		...rest
	} = props;

	const errorText = errors[name];
	const error = !!(touched[name] && errorText);

	return {
		name,
		error,
		value: values[name],
		helperText: error ? errorText : helperText,
		...rest
	};
});



// WEBPACK FOOTER //
// ./src/client/components/admin/common/form/with-value.js